export default __webpack_public_path__ + "static/harecloset-5a4632573880f3d6ce34018e369ae29d.png";